import { Box } from '@rbilabs/universal-components';

export const ProductDetailBackArrowContainer = Box.withConfig({
  position: 'absolute',
  left: '$4',
});
